import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import {Space} from 'antd'
import styles from './ProjectsListPanel.module.scss'
import {ProjectType} from 'modules/project'
import {
  Search,
  // FilterIcon, Filter, Button, IconButton, CloseCircleIcon,
} from 'common/components'
import {maybePluralize} from 'common/helpers'
import {SetFilter, SetSearch, /*FilterItem*/} from 'common/types'
import {
  // CURRENT_PROJECTS_INITIAL_FILTER,
  // ProjectFilterName,
  ProjectsFilter,
  ProjectFilterItems,
} from '..'

interface ProjectsListPanelProps {
  type: ProjectType
  projectsCount: number
  filterItems: ProjectFilterItems
  filter: ProjectsFilter
  search: string
  setFilter: SetFilter
  setSearch: SetSearch
}

// interface ProjectFilterProps {
//   name: ProjectFilterName
//   allTitle: string
//   label: string
//   filter: ProjectsFilter
//   items: FilterItem[]
//   setFilter: SetFilter
// }

// interface ClearFilterProps {
//   filter: ProjectsFilter
//   setFilter: SetFilter
// }

// const ProjectFilter = ({
//   name,
//   allTitle,
//   label,
//   filter,
//   items,
//   setFilter,
// }: ProjectFilterProps) => (
//   <Filter
//     values={filter[name]}
//     allTitle={allTitle}
//     label={label}
//     items={items}
//     renderButton={(label) => (
//       <Button dropdown variant="text">
//         {label}
//       </Button>
//     )}
//     setValues={(values: string[]) => setFilter({...filter, [name]: values})}
//   />
// )

// const ClearFilter = ({filter, setFilter}: ClearFilterProps) => {
//   if (!Object.values(filter).flat().length) return null

//   const handleClear = () => {
//     setFilter(CURRENT_PROJECTS_INITIAL_FILTER)
//   }

//   return (
//     <IconButton
//       icon={<CloseCircleIcon width={16} height={16} />}
//       onClick={handleClear}
//     />
//   )
// }

export default function ProjectsListPanel({
  type,
  projectsCount,
  // filterItems, filter,
  search,
  // setFilter,
  setSearch,
}: ProjectsListPanelProps) {
  const location = useLocation()

  useEffect(() => {
    if (undefined !== location?.state?.search) {
      // console.log(location?.state?.search)
      setSearch(location.state.search)
    }
  }, [location, setSearch])

  return (
    <div className={styles.root}>
      <Space size={36}>
        <h2 className={styles.title}>
          {maybePluralize(
            projectsCount,
            `${type === 'closed' ? 'closed ' : ''}project`
          )}
        </h2>
        <div className={styles.filters}>
          {/* <FilterIcon className={styles.icon} />
          <ProjectFilter
            name="region"
            allTitle="regions"
            label="Region"
            filter={filter}
            items={filterItems.region}
            setFilter={setFilter}
          />
          <ProjectFilter
            name="category"
            allTitle="loan types"
            label="Type"
            filter={filter}
            items={filterItems.category}
            setFilter={setFilter}
          />
          <ProjectFilter
            name="borrower"
            allTitle="borrowers"
            label="Borrower"
            filter={filter}
            items={filterItems.borrower}
            setFilter={setFilter}
          />
          {filterItems.manager && (
            <ProjectFilter
              name="manager"
              allTitle="managers"
              label="Manager"
              filter={filter}
              items={filterItems.manager}
              setFilter={setFilter}
            />
          )}
          <ClearFilter filter={filter} setFilter={setFilter} /> */}
        </div>
      </Space>
      <Search
        search={search}
        placeholder="title, user name"
        setSearch={setSearch}
      />
    </div>
  )
}
